import React from "react";
import Svg, { Path, Defs, Rect, G, ClipPath } from "react-native-svg";
import { TouchableOpacity } from "react-native";
import appStyles from "../../../appStyles";

export default function EditedHoursIcon(props) {
  return (
    <TouchableOpacity style={[appStyles.iconContainer, props.style]}>
      <Svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_editedHours)">
          <Path
            d="M11.4053 6.59494L7.28031 2.46994C6.98706 2.17669 6.51306 2.17669 6.21981 2.46994L0.969811 7.71994C0.873811 7.81594 0.805561 7.93669 0.772561 8.06794L0.0225606 11.0679C-0.0411894 11.3237 0.0338107 11.5937 0.219811 11.7804C0.362311 11.9229 0.553561 12.0002 0.750061 12.0002C0.810811 12.0002 0.871561 11.9927 0.932311 11.9777L3.93231 11.2277C4.06431 11.1947 4.18431 11.1264 4.28031 11.0304L9.00006 6.31069L9.81456 7.12519L7.34481 9.59494C7.05156 9.88819 7.05156 10.3622 7.34481 10.6554C7.63806 10.9487 8.11206 10.9487 8.40531 10.6554L11.4053 7.65544C11.6986 7.36219 11.6986 6.88819 11.4053 6.59494Z"
            fill="#ABADB3"
          />
          <Path
            d="M8.34082 1.40925L10.5908 3.65925L11.5343 2.71575C12.1553 2.09475 12.1553 1.08675 11.5343 0.46575C10.9133 -0.15525 9.90532 -0.15525 9.28432 0.46575L8.34082 1.40925Z"
            fill="#ABADB3"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_editedHours">
            <Rect width="12" height="12" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
